import factory from './icon';
import Svg from './glyphs/cart.svg';

export default factory(Svg);
